/**
 * 登录 / 注册页左侧轮播图：放在 `public/auth-login-carousel/`。
 * 在此数组中按顺序列出 URL（支持 .gif .jpg .png 等）；张数任意（1 张时不轮播）。
 */
export const AUTH_LOGIN_CAROUSEL_SRC: string[] = [
  '/auth-login-carousel/01.gif?v=2',
  '/auth-login-carousel/02.gif',
];

export const AUTH_LOGIN_CAROUSEL_INTERVAL_MS = 3.5 * 1000;
